import { __read } from "tslib";
import { getDefaultBrowser, getDefaultDocument } from './defaults';
export function onPageLoad(callback) {
    var window = getDefaultBrowser();
    var document = getDefaultDocument();
    if (!window || !document)
        return;
    if (document.readyState === 'complete') {
        callback();
        return;
    }
    window.addEventListener('load', function () {
        setTimeout(function () {
            callback();
        }, 0);
    }, false);
}
export var invokeCallbackOnce = function (cb) {
    var hasInvoked = false;
    var invoke = function (params) {
        if (hasInvoked)
            return;
        hasInvoked = true;
        cb && cb(params);
    };
    return [invoke];
};
export var onPageUnload = function (cb) {
    var _a = __read(invokeCallbackOnce(cb), 1), invokeCbOnce = _a[0];
    ['unload', 'beforeunload', 'pagehide'].forEach(function (ev) {
        addEventListener(ev, invokeCbOnce);
    });
};
export var onceHidden = function (cb) {
    if (document.visibilityState === 'hidden') {
        cb();
        return;
    }
    var onVisibilityChange = function () {
        if (document.visibilityState === 'hidden') {
            cb();
            removeEventListener('visibilitychange', onVisibilityChange, true);
        }
    };
    addEventListener('visibilitychange', onVisibilityChange, true);
};
export var loadScript = function (url, callback) {
    var _a;
    /* istanbul ignore next */
    var document = getDefaultDocument();
    // untestable for now
    /* istanbul ignore next */
    if (document) {
        var script = document.createElement('script');
        script.src = url;
        script.crossOrigin = 'anonymous';
        script.onload = callback;
        (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(script);
    }
};
//# sourceMappingURL=misc.js.map